import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional, ApiResponseProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsIn, IsNumber, IsOptional, Max, Min, ValidateNested } from 'class-validator';
import { DefaultStoreExposeGroup, delayedOrderDeliveryStepSizes } from '../interface';
import { IsDaysDelayLessOrEqualThan } from '../validator';
import { AbstractDefaultStoreDelayedOrdersDelayRangeConfigDto } from './AbstractDefaultStoreDelayedOrdersDelayRangeConfigDto';
import { DefaultStoreIntervalSettingsDto } from './DefaultStoreIntervalSettingsDto';
import { DefaultStorePushOrdersToNextDayByValueDto } from './DefaultStorePushOrdersToNextDayByValueDto';
export class AbstractDefaultStoreDelayedOrdersDto {
}
__decorate([
    ApiProperty({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], AbstractDefaultStoreDelayedOrdersDto.prototype, "isEnabledDelayedOrder", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, example: false }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], AbstractDefaultStoreDelayedOrdersDto.prototype, "isDisabledASAP", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 45, minimum: 0 }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Min(0, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], AbstractDefaultStoreDelayedOrdersDto.prototype, "minDelay", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 450, minimum: 0 }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Min(0, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], AbstractDefaultStoreDelayedOrdersDto.prototype, "maxDelay", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 30, minimum: 0 }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsIn(delayedOrderDeliveryStepSizes, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], AbstractDefaultStoreDelayedOrdersDto.prototype, "delayStepSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => DefaultStoreIntervalSettingsDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    Type(() => DefaultStoreIntervalSettingsDto),
    ValidateNested({ groups: [DefaultStoreExposeGroup.PATCH, DefaultStoreExposeGroup.UPDATE] }),
    __metadata("design:type", DefaultStoreIntervalSettingsDto)
], AbstractDefaultStoreDelayedOrdersDto.prototype, "intervalSettings", void 0);
__decorate([
    ApiResponseProperty({ type: () => Number, example: 60 }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ] }),
    __metadata("design:type", Number)
], AbstractDefaultStoreDelayedOrdersDto.prototype, "preFulfillmentMinutes", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 60, minimum: 0, description: 'Additional delay for pos printing (in minutes)' }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Min(0, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], AbstractDefaultStoreDelayedOrdersDto.prototype, "extraPosPrintingMinutes", void 0);
__decorate([
    ApiResponseProperty({ type: () => AbstractDefaultStoreDelayedOrdersDelayRangeConfigDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ] }),
    Type(() => AbstractDefaultStoreDelayedOrdersDelayRangeConfigDto),
    __metadata("design:type", AbstractDefaultStoreDelayedOrdersDelayRangeConfigDto)
], AbstractDefaultStoreDelayedOrdersDto.prototype, "delayRangeConfig", void 0);
__decorate([
    ApiPropertyOptional({ type: () => DefaultStorePushOrdersToNextDayByValueDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    Type(() => DefaultStorePushOrdersToNextDayByValueDto),
    ValidateNested({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsDaysDelayLessOrEqualThan('maxDelay', { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", DefaultStorePushOrdersToNextDayByValueDto)
], AbstractDefaultStoreDelayedOrdersDto.prototype, "pushOrdersToNextDayByValue", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 45, minimum: 0 }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Min(0, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Max(60 * 24, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], AbstractDefaultStoreDelayedOrdersDto.prototype, "openingHoursDelay", void 0);
//# sourceMappingURL=AbstractDefaultStoreDelayedOrdersDto.js.map